module.exports = __webpack_public_path__ + "static/img/cabecera.ee19b67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/proveedores/cabecera.jpg
// module id = Gksi
// module chunks = 0